import { Modal } from "@mui/material";
import styles from "./styles.module.scss";
import classNames from "classnames";
import CloseIcon from "../../../../../assets/images/svg/remove.svg";

import ManualAdvancedSettlement from "./ManualAdvancedSettlement";
import { useTranslation } from "react-i18next";

interface ISettlementModal {
  open: boolean;
  handleClose: () => void;
  propose?: boolean;
}

const AdvancedSettlementModal = ({
  open,
  handleClose,
  propose,
}: ISettlementModal) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={styles.modalContainer}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className={classNames(styles["card"], styles["modal_body"])}>
        <div className={styles["modal_header"]}>
          <h1 className={styles["h1"]}>{t("global_status_settlement")}</h1>
          <img
            src={CloseIcon}
            alt=""
            className={styles["close_icon"]}
            onClick={handleClose}
          />
        </div>
        <ManualAdvancedSettlement propose={propose} />
      </div>
    </Modal>
  );
};

export default AdvancedSettlementModal;
